import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  answers: css`
    width: auto;
    padding-block: ${spacing(1)};
  `,
  column: css`
  margin-inline: ${spacing(-2)}
  padding-inline: ${spacing(2)}
  padding-block-start: 0;
  padding-block-end: ${spacing(1.5)};
  /* Disable scrollbar */
  overflow-x: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
  `,
  root: css`
    padding-inline: ${spacing(2)};
    position: relative;
    &::before {
      content: '';
      position: absolute;
      inset-block-start: 0;
      inset-inline: ${spacing(2)};
      block-size: ${spacing(0.125)};
      background-color: ${cssTheme.colors.warmGray[200]};
    }
  `,
  text: css`
    padding-block: ${spacing(1.5)};
  `,
}
